<template>
  <v-app id="vapp">
    <!--version 0.9.02-->
    <!--//@*/*
    //    *RPD  Appv0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC . All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- mobile menu bar  hidden-sm-and-up -->
    <v-row class="menu-bar-row">
      <v-col cols="12">
        <v-app-bar
          id="menu-bar-mobile"
          fixed
          app
          class="d-flex d-sm-none"
          absolute
          dense
          white--text
        >
          <v-app-bar-nav-icon
            v-show="true"
            @click="drawer = true"
            style="color: aliceblue"
          ></v-app-bar-nav-icon>
          <v-spacer></v-spacer>

          <v-img
            max-width="48px"
            height="48px"
            width="auto"
            src="../images/gold-badge-48px.png"
          ></v-img>
          <v-spacer></v-spacer>

          <div id="div_logoff">
            <v-btn icon text v-show="true">
              <v-icon x-large style="color: lightslategrey">$person</v-icon>
            </v-btn>
          </div>
        </v-app-bar>
      </v-col>
    </v-row>

    <v-navigation-drawer
      id="v-navigation-drawer"
      class="white--text mt-11"
      style="background-color: #2c3e50"
      v-model="drawer"
      height="215"
      width="175"
      accent
      absolute
      temporary
    >
      <v-list nav dense close-on-click close-on-content-click>
        <v-list-item-group v-model="group" class="white--text">
          <v-list-item>
            <router-link class="white--text" to="/"
              >Training Reports</router-link
            >
          </v-list-item>

          <v-list-item>
            <router-link class="white--text" to="/afteraction_reports"
              >After Action Reports</router-link
            >
          </v-list-item>

          <v-list-item>
            <router-link class="white--text" to="/reports">Reports</router-link>
          </v-list-item>

          <v-list-item>
            <router-link class="white--text" to="/roster_logs"
              >Lists</router-link
            >
          </v-list-item>
          <v-list-item>
            <a
              class="white--text"
              href="https://rpdportal.org/?returnURL=https://swat.renoportal.org"
              target="_blank"
              >Apps Home</a
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Large Menu Bar -->
    <v-row class="menu-bar-row">
      <v-col cols="12">
        <v-app-bar
          id="menu-bar-large"
          app
          class="app_vue_comp flex-row align-center justify-space-between white--text hidden-xs-only"
          elevation="4"
          style="height: 50px; background-color: #b8bbd7"
        >
          <img class="img1" src="../images/gold-badge-320.png" />

          <router-link
            to="/"
            active-class="my-active-class"
            class="menulink"
            id="trainlink"
            >Training Reports</router-link
          >

          <router-link
            to="/afteraction_reports"
            color="accent"
            active-class="my-active-class"
            class="menulink"
            id="aactionlink"
            >After Action Reports</router-link
          >
          <router-link
            to="/reports"
            color="accent"
            active-class="my-active-class"
            class="menulink"
            id="reportslink"
            >Reports</router-link
          >

          <router-link
            to="/roster_logs"
            color="accent"
            active-class="my-active-class"
            class="menulink"
            id="rosterslink"
            >Lists</router-link
          >

          <a
            href="https://rpdportal.org/?returnURL=https://swat.renoportal.org"
            target="_blank"
            >Apps Home</a
          >
        </v-app-bar>
      </v-col>
    </v-row>

    <v-main id="main">
      <Transition name="fade-transition" mode="out-in">
        <keep-alive include="reports">
          <router-view />
        </keep-alive>
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
/* 0 media q */
@media (min-width: 0px) {
  .tab-active {
    color: #e3cc67;
  }
  .v-main {
    padding: 5px 0 0 0 !important;
  }
  .menu-bar-row {
    height: 50px;
    flex-grow: 0 !important;
  }

  #vapp {
    /* background-color: var(--v-background-base); */
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 100vh;
    height: 100vh;
    background-color: aliceblue;
    min-height: 100%;
    max-width: 1025px;
    margin: 0 auto;
    /* background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: cover; */
  }

  .v-toolbar {
    max-width: 1025px;
    margin: 0 auto;
  }

  #menu-bar-large .v-toolbar__content,
  #menu-bar-mobile .v-toolbar__content {
    width: 100%;
    max-width: 1025px;
    height: 50px !important;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
    background-color: #2c3e50;
  }

  #menu-bar-large img.img1 {
    width: 48px;
  }

  #menu-bar-mobile .v-application:deep .primary {
    background-color: aliceblue !important;
    border-color: aliceblue !important;
  }

  .my-active-class {
    color: orange;
  }

  #v-navigation-bar {
    background-color: #2c3e50;
  }
  .bk-color {
    margin: 5px;
    border-radius: 4px;
  }
  .bk-color:hover {
    background: #bbdefb;
  }
  .bk-color:active {
    background: #e3f2fd;
  }

  /* .img2 img {
    width: 400px;
  }

  .img3 img {
    width: 400px;
  } */

  #menu-bar-large a {
    color: white;
    text-decoration: none;
    font-size: 1.2rem;
  }

  #menu-bar-large a:hover {
    color: #e3cc67;
  }

  #menu-bar-large a:active {
    color: #b08533;
  }

  .swal2-popup {
    /* font-size: 1.15rem !important;*/
    font-family: "Roboto", sans-serif !important;
  }
  .v-btn--active.no-active::before {
    opacity: 0 !important;
  }

  .v-btn--active.no-active:not(:hover)::before {
    opacity: 0 !important;
  }
}

@media only screen and (max-width: 600px) {
  #vapp {
    max-height: 93vh;
  }
}

@media (min-width: 768px) {
}

@media (min-width: 1025px) {
  #vapp {
    /* background-image: url("../images/reno-hero_1920.png"); */
    /*background-image: url("../images/hero_placeholder.jpg");
    background-position: 0 100px;*/
    max-width: 1025px;
  }
}

@media (min-width: 2048px) {
}
</style>

<script>
// import brandbar from "./brandbar";
import { bus_common } from "../mixins/bus_common";

export default {
  name: "App",
  mixins: [bus_common],
  // components: { auth },

  data() {
    return {
      zIndex: 4000,
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.loader_visible": function () {
      //console.log("app loader_visible " + this.$store.state.loader_visible );
    },
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
  },
  methods: {
    menu_click(e) {
      console.log("targ");
    },
    logout() {
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        null,
        "Yes",
        "No",
        null
      );
    },
  },
  created() {
    this.show_loader(true);
  },
};
</script>
